import type { FetcherAxiosInstance } from '../fetcher';

export const createAuthApi = (Fetcher: FetcherAxiosInstance) => ({
  requestCodeV1({
    phone = '', email = '', channel = 'sms',
  } = {}) {
    return Fetcher.post('/auth/code', { token: phone || email, channel, recaptcha: 'recaptcha' });
  },

  requestAuthCode({
    phone = '', email = '', channel = 'sms',
  } = {}) {
    return Fetcher.post('/auth/code', { token: phone || email, channel }, { baseURL: '/web-api/v2' });
  },

  verifyAuthCode({
    phone = '', email = '', channel = 'sms', code,
  } = {}) {
    return Fetcher.post('/auth/code/_verifying', { token: phone || email, channel, code });
  },

  registration({
    name, email, phone, subscription, territoryId,
  }) {
    return Fetcher.post('/auth/_registration', {
      name, email, phone, subscription, territoryId,
    });
  },

  login({ token }) {
    return Fetcher.post('/auth/_login', {}, { params: { token } });
  },

  logout() {
    return Fetcher.post('/auth/_logout');
  },

  fetchAccessToken() {
    return Fetcher.post('/auth/token', {}, { _retrySkip: true });
  },
});
